import { FIXED_ORDER_FIELD_NAMES } from "@/modules/Orders/constants/OrderConstants";

export const NEW_ACTION = "Nueva acción";

export const ACTION_CONFIGURATION = "Configuración de acción";

export const USER_EDITION = "Edición de usuarios";

export const USER_EDITION_FIELD = "Campo de usuario a modificar";

export const USERS_TAG = "Usuarios";

export const MEDICAL_ORDER_CONSTANTS = {
  TITLE: "Edición de órdenes médicas",
  SUB_TITLE: "Campos de órdenes a modificar",
  FIXED_FIELDS: "Campos fijos",
  CUSTOM_FIELDS: "Campos personalizados",
  LABELS: {
    PRICE_LEVEL: FIXED_ORDER_FIELD_NAMES.PRICE_LEVEL,
    BILL_TYPE: FIXED_ORDER_FIELD_NAMES.BILL_TYPE,
    STATE: FIXED_ORDER_FIELD_NAMES.STATE,
    ORDER_TYPE: FIXED_ORDER_FIELD_NAMES.ORDER_TYPE,
    DIAG_CODE: FIXED_ORDER_FIELD_NAMES.DIAG_CODE,
    CAMPUS: FIXED_ORDER_FIELD_NAMES.CAMPUS,
    CANCEL_VALUE: FIXED_ORDER_FIELD_NAMES.CANCEL_VALUE,
    SERVICE_VALUE: FIXED_ORDER_FIELD_NAMES.SERVICE_VALUE
  }
};

export const ACTION_EVENT = {
  NOTIFICATION: "notification",
  DATA: "data",
  TASK: "task",
  MEDICAL_ORDER: "medicalOrder",
  CRATE_MEDICAL_ORDER: "newMedicalOrder",
  CHANGE_STATE: "changeState"
};

export const COMPARISON_FILTERS = {
  MEDICAL_ORDERS: "medicalOrders",
  FORMS: "forms",
  USERS: "users",
  TASKS: "tasks",
  SERVICES: "services"
};

export const ACTION_CARD_EVENT = {
  SEARCH_DATA_BY_NAME: "searchDataByName",
  SEARCH_ROLE_BY_NAME: "searchRoleByName",
  SEARCH_DEPENDENCY_BY_NAME: "searchDependencyByName",
  SEARCH_INFO_GROUP_BY_NAME: "searchInfoGroupByName",
  SELECTED_DATA: "selectedData",
  SEND_DATA_ACTION: "sendDataAction",
  IS_DUPLICATED: "isDuplicated",
  CANCEL_DATA: "cancelData"
};

export const SELECT_ACTION = {
  SEND_NOTIFICATION: "Enviar notificación",
  CREATE_TASK: "Crear tarea",
  EDIT_USERS: "Editar usuarios",
  EDIT_MEDICAL_ORDER: "Editar órdenes médicas",
  CREATE_ORDER: "Crear Orden",
  UPDATE_TASK_STATE: "Actualizar estado",
  CHANGE_STATE: "Cambiar estado",
  REASING_TASKS: "Reasignar tareas",
  ASSIGN_TASKS_TO_DEPENDENCY: "Asignar tareas a dependencia"
};

export const USER_DATA_ACTION = {
  STATE: "state",
  ADD_ROLE: "addRole",
  REMOVE_ROLE: "removeRole",
  EXTRA_INFO_GROUP: "extraInfoGroups",
  ADD_DEPENDENCY: "addDependency",
  REMOVE_DEPENDENCY: "removeDependency"
};

export const SELECT_ACTION_ARRAY: { [key: string]: string | boolean }[] = [
  {
    title: SELECT_ACTION.SEND_NOTIFICATION,
    value: ACTION_EVENT.NOTIFICATION,
    active: true
  },
  {
    title: SELECT_ACTION.CREATE_TASK,
    value: ACTION_EVENT.TASK,
    active: true
  },
  {
    title: SELECT_ACTION.EDIT_USERS,
    value: ACTION_EVENT.DATA,
    active: false
  },
  {
    title: SELECT_ACTION.CREATE_ORDER,
    value: ACTION_EVENT.CRATE_MEDICAL_ORDER,
    active: false
  }
];

export const SELECT_ACTION_ARRAY_MEDICAL_ORDER = [
  {
    title: SELECT_ACTION.SEND_NOTIFICATION,
    value: ACTION_EVENT.NOTIFICATION,
    active: true
  },
  {
    title: SELECT_ACTION.CREATE_TASK,
    value: ACTION_EVENT.TASK,
    active: true
  },
  {
    title: SELECT_ACTION.EDIT_USERS,
    value: ACTION_EVENT.DATA,
    active: false
  },
  {
    title: SELECT_ACTION.EDIT_MEDICAL_ORDER,
    value: ACTION_EVENT.MEDICAL_ORDER,
    active: true
  }
];

export const USER_DATA_ACTION_ARRAY = [
  {
    title: "Estado",
    value: USER_DATA_ACTION.STATE
  },
  {
    title: "Agregar rol",
    value: USER_DATA_ACTION.ADD_ROLE
  },
  {
    title: "Remover rol",
    value: USER_DATA_ACTION.REMOVE_ROLE
  },
  {
    title: "Agregar grupo de información adicional",
    value: USER_DATA_ACTION.EXTRA_INFO_GROUP
  },
  {
    title: "Agregar Dependencia",
    value: USER_DATA_ACTION.ADD_DEPENDENCY
  },
  {
    title: "Remover Dependencia",
    value: USER_DATA_ACTION.REMOVE_DEPENDENCY
  }
];

export const NEW_ACTION_LABEL = {
  SELECT_CHOOSE_ACTION: "Selecciona una acción a realizar",
  SELECT_CHOOSE_DATA: "Selecciona el dato que vas a modificar",
  SELECT_STATE: "Selecciona el estado",
  SELECT_ROLE: "Selecciona el rol de usuario",
  SELECT_DEPENDENCY: "Selecciona la dependencia de usuario",
  SELECT_INFO_GROUP: "Selecciona el grupo de información",
  SEARCH_NAME: "Elige un valor para buscar",
  NEW_ACTION_BTN_LABEL: "Ejecutar acción",
  TYPE_AND_ENTER: "Escribe el nombre del elemento y presiona la tecla enter",
  MULTIPLE_NOTIFICATIONS_ALLOWED:
    "Permitir múltiples notificaciones por usuario"
};

export const DOCUMENT_STATES = {
  ACTIVE: "Activo",
  INACTIVE: "Inactivo"
};

export const DOCUMENT_STATES_ARRAY = [
  DOCUMENT_STATES.ACTIVE,
  DOCUMENT_STATES.INACTIVE
];

export const ACTION_MESSAGE = {
  FAILED: "La ejecución de la acción falló",
  NO_USERS: "Debe elegir al menos un usuario para efectuar la acción",
  NO_PATIENT:
    "Debe cargar la información de los usuarios y elegir al menos uno tipo paciente para efectuar la acción",
  TOO_MANY_USERS: "Esta acción requiere solo un usuario",
  NO_PATIENT_ROL:
    "El usuario selecionado no es un paciente o se encuentra inactivo"
};

export const MEDICAL_ORDER_PROPERTIES = {
  STATE: "state",
  BILL_TYPE: "billType",
  DIAG_CODE: "diagnosticPrimaryCode",
  CANCEL_VALUE: "cancelValue",
  NRO_MEDICAL_ORDER: "nroMedicalOrder"
};

export const MEDICAL_ORDER_PROPERTIES_ARRAY = [
  MEDICAL_ORDER_PROPERTIES.STATE,
  MEDICAL_ORDER_PROPERTIES.BILL_TYPE,
  MEDICAL_ORDER_PROPERTIES.DIAG_CODE,
  MEDICAL_ORDER_PROPERTIES.CANCEL_VALUE
];

export const EDIT_FIELD_ERROR = "Debe modificar al menos un campo";
export const ACTION_MODAL_TITLE = "Campos opcionales editados";
export const ACTION_MODAL_TEXT =
  "Está editando campos opcionales, algunos de estos campos pueden no estar diligenciados en las órdenes que va a editar. Si continúa, estos campos serán agregados a la orden médica editada";

export const DASHBOARD_ACCESS = {
  GET: "consultar tablero administrativo",
  POST: "ejecutar acciones"
};

export const ACTIONS_TASK = {
  UPDATE_TASK_STATE: "updateTasksState",
  REASING_TASKS: "reasingTasks",
  ASSIGN_TASKS_TO_DEPENDENCY: "assignTaskToDependency"
};
export const SELECT_ACTION_ARRAY_TASK = [
  {
    title: SELECT_ACTION.UPDATE_TASK_STATE,
    value: ACTIONS_TASK.UPDATE_TASK_STATE,
    active: true
  },
  {
    title: SELECT_ACTION.REASING_TASKS,
    value: ACTIONS_TASK.REASING_TASKS,
    active: true
  }
  // actualmente no se esta utilizando filtro de tareas por dependencia
  // {
  //   title: SELECT_ACTION.ASSIGN_TASKS_TO_DEPENDENCY,
  //   value: ACTIONS_TASK.ASSIGN_TASKS_TO_DEPENDENCY,
  //   active: true
  // }
];

export const ACTIONS_TASK_ARRAY = [
  ACTIONS_TASK.UPDATE_TASK_STATE,
  ACTIONS_TASK.REASING_TASKS,
  ACTIONS_TASK.ASSIGN_TASKS_TO_DEPENDENCY
];

export const ACTIONS_TEXT: { [key: string]: string } = {
  [ACTIONS_TASK.UPDATE_TASK_STATE]: SELECT_ACTION.UPDATE_TASK_STATE,
  [ACTIONS_TASK.REASING_TASKS]: SELECT_ACTION.REASING_TASKS,
  [ACTIONS_TASK.ASSIGN_TASKS_TO_DEPENDENCY]:
    SELECT_ACTION.ASSIGN_TASKS_TO_DEPENDENCY
};

export const ACTION_TASK_CONSTANTS = {
  NO_ITEMS_SELECTED: "Debe elegir al menos un registro para efectuar la acción",
  EMMITS: {
    HANDLE_TASK_ACTIONS: "handleTaskActions",
    CLOSE_TASK_ACTIONS_MODAL: "closeTaskActionsModal",
    UPDATE_STATE: "update:state",
    UPDATE_USER_ID: "update:usersId",
    UPDATE_DEPENDENCY: "update:dependency",
    ADD_RESPONSIBLE: "addResponsible"
  },
  LABELS: {
    CLOSE_BTN: "Cerrar",
    CANCEL_BTN: "Cancelar",
    ACCEP_BTN: "Aceptar",
    STATE_LABEL: "Seleccione nuevo estado de las tareas*",
    NAME: "Nombre: ",
    DOCUMENT: "Documento: ",
    PHONE: "Tel: ",
    AVATAR: "Avatar",
    DEPENDENCY_LABEL: "Seleccione una dependencia*",
    ITEMS_WITH_ERRORS: "Registros con erores: ",
    ITEMS_SUCCESS: "Registros exitosos: ",
    EMPTY_STATE_HEADER: "No hay información para mostrar",
    TASK_LABEL: "Tarea: ",
    FORMS_LABEL: "Formulario: ",
    TASK_ID: "ID: ",
    NO_DEPENDENCIES: "No hay dependencias"
  }
};
